module.exports = __webpack_public_path__ + "static/big-f86a2b216021a129d4a8fbfa7a3a40ef.png";